module.exports = __webpack_public_path__ + "static/media/pharmacy1-150.4bdaa9b5.webp";